import { benefits } from "@/config/content";
import { Reveal } from "@/lib/motion";

export const Benefits = () => (
  <section className="py-20 lg:py-28 bg-sand grain relative" data-testid="benefits-section">
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative">
      <Reveal className="max-w-3xl">
        <p className="text-xs font-semibold uppercase tracking-[0.2em] text-gold-dark mb-4">Warum HANSERA</p>
        <h2 className="font-heading font-extrabold tracking-tight text-3xl sm:text-4xl lg:text-5xl text-charcoal leading-[1.15]">
          Zuverlässige Leistungen ohne unnötige Umwege
        </h2>
      </Reveal>
      <div className="mt-12 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
        {benefits.map((b, i) => (
          <Reveal key={b.title} delay={i * 0.05}>
            <div data-testid="benefit-card" className="h-full rounded-2xl border border-border bg-white p-7 hover:-translate-y-1 hover:shadow-[0_12px_40px_rgb(0,0,0,0.08)] transition-[transform,box-shadow] duration-300">
              <span className="inline-flex items-center justify-center w-12 h-12 rounded-xl bg-forest/8 text-forest mb-5">
                <b.icon className="w-6 h-6" strokeWidth={1.75} />
              </span>
              <h3 className="font-heading font-bold text-lg text-charcoal">{b.title}</h3>
              <p className="mt-2.5 text-charcoal-muted leading-relaxed">{b.text}</p>
            </div>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
